module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-395.694c5e7.woff2";